import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/styles.scss';

const Modal = (props) => {
  return (
    <div>
      <div className="background">&nbsp;</div>
      <div className="popup center">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{props.header}</h5>
            <button type="button" className="close" onClick={props.closeFunction}>
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            {props.children}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={props.closeFunction}>{props.closeLabel}</button>
            {props.confirmLabel && <button type="button" className="btn btn-primary" onClick={props.confirmFunction}>{props.confirmLabel}</button>}
          </div>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  header: PropTypes.string,
  closeFunction: PropTypes.func,
  confirmFunction: PropTypes.func,
  closeLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  children: PropTypes.any,
};

export default Modal;
